module.exports = {"data":{"markdownRemark":{"html":"<p>Put recipe here</p>","frontmatter":{"date":"July 12, 2017","path":"/blog/non-stick-cookie-dough-recipe","title":"Non-Stick Cookie Dough Recipe","image":"/images/ssl.jpg"}}},"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/blog-non-stick-cookie-dough-recipe.json
// module id = 345
// module chunks = 185166916064630